import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux'
import { pendingTasksReducer } from 'react-redux-spinner'

import root from './root'
import schedule from './schedule';
import session from './session';
import { reducer as oidcReducer } from 'redux-oidc';


const appReducer = combineReducers({
    schedule,
    session,
    oidc: oidcReducer,
    pendingTasks: pendingTasksReducer,
    routing: routerReducer
});

const rootReducer = (state, action) => {
    state = root(state, action);
    return appReducer(state, action)
};

export default rootReducer;
